import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Reset scroll position on every route change (except in-page anchors and back/forward restores)
const ScrollToTop = () => {
  const { pathname, search, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) { el.scrollIntoView({ block: 'start' }); return; }
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname, search, hash]);
  return null;
};

export default ScrollToTop;
